import React from "react";
import { Spin } from "antd";
import type { SpinProps } from "antd";

type PageLoaderProps = SpinProps;

const PageLoader: React.FC<PageLoaderProps> = ({ size = "large", ...rest }) => (
  <Spin size={size} {...rest} />
);

export default PageLoader;
